import { useExperiment } from '~/features/experiments/hooks/use-experiment';

export function usePriceCardUspsVariant() {
  const experiment = useExperiment();
  return experiment?.ab_price_card_usps;
}
